import { createContext } from 'react';

const ModalContext = createContext({
  component: null,
  props: {},
  activeId: null,
  overlayType: 'touchclose',
  onClose: null,
  showModal: () => {},
  hideModal: () => {}
});

export default ModalContext;
